import { getAuthData } from './storage.service';
import { refreshTokenService } from './auth.service';

export const validateAuth = async (): Promise<boolean> => {
  const authData = getAuthData();
  
  if (!authData) {
    return false;
  }
  
  const now = Date.now();
  const expirationTime = new Date(authData.expiresIn).getTime();
  
  if (now >= expirationTime) {
    const refreshedData = await refreshTokenService();
    return !!refreshedData;
  }
  
  return true;
}; 